// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-password-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f3f4f6;
  position: relative;
}

.reset-password-card {
  background-color: #fffdfc;
  padding: 3rem;
  border-radius: 0.8rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 40rem;
  text-align: center;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

.logo {
  width: 12rem;
  height: auto;
}

.reset-password-card h1 {
  color: #2c3948;
  font-size: 2.4rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}

.reset-password-content {
  margin: 2.5rem 0;
}

.reset-password-content p {
  color: #2c3948;
  font-size: 1.6rem;
  margin-bottom: 2rem;
}

.reset-password-back-home {
  position: absolute;
  top: 1.75rem;
  left: 2rem;
  color: #6b7280;
  font-size: 1.2rem;
  text-decoration: none;
  transition: color 0.15s;
}

.reset-password-back-home:hover {
  color: #374151;
}

.reset-password-card .form-group {
  margin-bottom: 2rem;
  text-align: left;
}

.reset-password-card .form-group label {
  display: block;
  color: #2c3948;
  font-size: 1.4rem;
  margin-bottom: 0.8rem;
}

.reset-password-card .form-group input {
  width: 100%;
  padding: 1.2rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  font-size: 1.6rem;
  color: #2c3948;
}

.reset-password-card .form-group input:focus {
  outline: none;
  border-color: #f97316;
}

.password-input-container {
  position: relative;
}

.toggle-password-btn {
  position: absolute;
  right: 1.2rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0.6rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-password-btn svg {
  width: 2rem;
  height: 2rem;
  color: #2c3948;
}

.toggle-password-btn:hover svg {
  color: #f97316;
}

.password-requirements {
  margin-top: 1rem;
  padding: 1rem;
  background-color: #f9fafb;
  border-radius: 0.5rem;
}

.password-requirements p {
  font-size: 1.4rem;
  margin-bottom: 0.5rem;
}

.password-requirements ul {
  list-style: none;
  padding-left: 1rem;
}

.password-requirements li {
  margin-bottom: 0.4rem;
  font-size: 1.3rem;
  position: relative;
  padding-left: 2rem;
}

.password-requirements li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
}

.password-requirements li.valid::before {
  background-color: #22c55e;
}

.password-requirements li.invalid::before {
  background-color: #ef4444;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  margin-top: 2rem;
}

.error-message {
  background-color: #fee2e2;
  color: #b91c1c;
  padding: 1rem;
  border-radius: 0.5rem;
  margin: 1rem 0;
  text-align: left;
}

.success-message {
  background-color: #dcfce7;
  color: #166534;
  padding: 1rem;
  border-radius: 0.5rem;
  margin: 1rem 0;
}

.reset-password-footer {
  margin-top: 2rem;
  color: #6b7280;
  font-size: 1.4rem;
}

.reset-password-back-login {
  display: inline-block;
  margin-top: 1rem;
  color: #f97316;
  font-size: 1.4rem;
  text-decoration: none;
  font-weight: 500;
}

.reset-password-back-login:hover {
  color: #ea6a00;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ResetPassword/ResetPassword.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".reset-password-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f3f4f6;\n  position: relative;\n}\n\n.reset-password-card {\n  background-color: #fffdfc;\n  padding: 3rem;\n  border-radius: 0.8rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 40rem;\n  text-align: center;\n}\n\n.logo-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 2rem;\n}\n\n.logo {\n  width: 12rem;\n  height: auto;\n}\n\n.reset-password-card h1 {\n  color: #2c3948;\n  font-size: 2.4rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n}\n\n.reset-password-content {\n  margin: 2.5rem 0;\n}\n\n.reset-password-content p {\n  color: #2c3948;\n  font-size: 1.6rem;\n  margin-bottom: 2rem;\n}\n\n.reset-password-back-home {\n  position: absolute;\n  top: 1.75rem;\n  left: 2rem;\n  color: #6b7280;\n  font-size: 1.2rem;\n  text-decoration: none;\n  transition: color 0.15s;\n}\n\n.reset-password-back-home:hover {\n  color: #374151;\n}\n\n.reset-password-card .form-group {\n  margin-bottom: 2rem;\n  text-align: left;\n}\n\n.reset-password-card .form-group label {\n  display: block;\n  color: #2c3948;\n  font-size: 1.4rem;\n  margin-bottom: 0.8rem;\n}\n\n.reset-password-card .form-group input {\n  width: 100%;\n  padding: 1.2rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n  font-size: 1.6rem;\n  color: #2c3948;\n}\n\n.reset-password-card .form-group input:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n.password-input-container {\n  position: relative;\n}\n\n.toggle-password-btn {\n  position: absolute;\n  right: 1.2rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  padding: 0.6rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.toggle-password-btn svg {\n  width: 2rem;\n  height: 2rem;\n  color: #2c3948;\n}\n\n.toggle-password-btn:hover svg {\n  color: #f97316;\n}\n\n.password-requirements {\n  margin-top: 1rem;\n  padding: 1rem;\n  background-color: #f9fafb;\n  border-radius: 0.5rem;\n}\n\n.password-requirements p {\n  font-size: 1.4rem;\n  margin-bottom: 0.5rem;\n}\n\n.password-requirements ul {\n  list-style: none;\n  padding-left: 1rem;\n}\n\n.password-requirements li {\n  margin-bottom: 0.4rem;\n  font-size: 1.3rem;\n  position: relative;\n  padding-left: 2rem;\n}\n\n.password-requirements li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 1.2rem;\n  height: 1.2rem;\n  border-radius: 50%;\n}\n\n.password-requirements li.valid::before {\n  background-color: #22c55e;\n}\n\n.password-requirements li.invalid::before {\n  background-color: #ef4444;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.5rem;\n  margin-top: 2rem;\n}\n\n.error-message {\n  background-color: #fee2e2;\n  color: #b91c1c;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin: 1rem 0;\n  text-align: left;\n}\n\n.success-message {\n  background-color: #dcfce7;\n  color: #166534;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin: 1rem 0;\n}\n\n.reset-password-footer {\n  margin-top: 2rem;\n  color: #6b7280;\n  font-size: 1.4rem;\n}\n\n.reset-password-back-login {\n  display: inline-block;\n  margin-top: 1rem;\n  color: #f97316;\n  font-size: 1.4rem;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.reset-password-back-login:hover {\n  color: #ea6a00;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
